import { LOCATION_CHANGE } from "connected-react-router";
import { FETCH_PRODUCT_BY_USERID_REQUESTED,
  FETCH_PRODUCT_BY_USERID_FAILURE,
  FETCH_PRODUCT_BY_USERID_SUCCESS,
  FETCH_SERVICE_BY_USERID_REQUESTED,
  FETCH_SERVICE_BY_USERID_SUCCESS,
  FETCH_SERVICE_BY_USERID_FAILURE,
  ADD_SERVICE_PRODUCT_REQUESTED,
  ADD_SERVICE_PRODUCT_SUCCESS,
  ADD_SERVICE_PRODUCT_FAILURE,
  UPDATE_SERVICE_BY_USERID,
  UPDATE_SERVICE_BY_USERID_SUCCESS,
  UPDATE_SERVICE_BY_USERID_FAILURE,
  GET_ACCEPTED_DELIVERED_REQUESTED,
  GET_ACCEPTED_DELIVERED_SUCCESS,
  GET_ACCEPTED_DELIVERED_FAILURE,
  GET_FAVOURITE_BUSINESS_SUCCESS, GET_FAVOURITE_BUSINESS_REQUESTED, GET_FAVOURITE_BUSINESS_FAILURE,
  ADD_FAVOURITE_BUSINESS_SUCCESS, ADD_FAVOURITE_BUSINESS_REQUESTED, ADD_FAVOURITE_BUSINESS_FAILURE,
  ADD_UN_FAVOURITE_BUSINESS_SUCCESS, ADD_UN_FAVOURITE_BUSINESS_REQUESTED, ADD_UN_FAVOURITE_BUSINESS_FAILURE,
  GET_RECOMMENDED_SERVICE_SUCCESS, GET_RECOMMENDED_SERVICE_REQUESTED, GET_RECOMMENDED_SERVICE_FAILURE } from "../actions/market-action-types";

const initialState = {
  fetchServices: "pending",
  fetchProducts: "pending",
  addServiceProduct: "pending",
  fetchServiceDataStatus: "pending",
  fetchProductDataStatus: "pending",
  addServiceProductStatus: "pending",
  acceptedDeliveredDataStatus: "pending",
  getFavouriteBuisnessDataStatus: "pending",
  addFavouriteBuisnessDataStatus: "pending",
  addUnFavouriteBuisnessDataStatus: "pending",
  getRecommendedServiceStatus: "pending",
  serviceData: [],
  productData: [],
  savedData: [],
  updateData: [],
  acceptedDeliveredData: [],
  getFavouriteBuisnessData: [],
  addFavouriteBuisnessData: [],
  addUnFavouriteBuisnessData: [],
  recommendedServiceData: [],
};

export default function market(state = initialState, {
  payload, type,
}) {
  switch (type) {
    case FETCH_SERVICE_BY_USERID_REQUESTED:
      return {
        ...state,
        fetchServiceDataStatus: "request",
      };

    case FETCH_SERVICE_BY_USERID_SUCCESS:
      return {
        ...state,
        fetchServiceDataStatus: "Success",
        serviceData: payload,
      };
    case FETCH_SERVICE_BY_USERID_FAILURE:
      return {
        ...state,
        fetchServiceDataStatus: "failed",
      };
    case FETCH_PRODUCT_BY_USERID_REQUESTED:
      return {
        ...state,
        fetchProductDataStatus: "request",
      };

    case FETCH_PRODUCT_BY_USERID_SUCCESS:
      return {
        ...state,
        fetchProductDataStatus: "Success",
        productData: payload,
      };
    case FETCH_PRODUCT_BY_USERID_FAILURE:
      return {
        ...state,
        fetchProductDataStatus: "failed",
      };
    case ADD_SERVICE_PRODUCT_REQUESTED:
      return {
        ...state,
        addServiceProductStatus: "request",
      };

    case ADD_SERVICE_PRODUCT_SUCCESS:
      return {
        ...state,
        addServiceProductStatus: "Success",
        savedData: payload,
      };
    case ADD_SERVICE_PRODUCT_FAILURE:
      return {
        ...state,
        addServiceProductStatus: "failed",
      };
    case UPDATE_SERVICE_BY_USERID:
      return {
        ...state,
        fetchProductDataStatus: "request",
      };
    case UPDATE_SERVICE_BY_USERID_SUCCESS:
      return {
        ...state,
        fetchProductDataStatus: "Success",
        updateData: payload,
      };
    case UPDATE_SERVICE_BY_USERID_FAILURE:
      return {
        ...state,
        fetchProductDataStatus: "failed",
      };
    case GET_ACCEPTED_DELIVERED_REQUESTED:
      return {
        ...state,
        acceptedDeliveredDataStatus: "request",
      };

    case GET_ACCEPTED_DELIVERED_SUCCESS:
      return {
        ...state,
        acceptedDeliveredDataStatus: "Success",
        acceptedDeliveredData: payload,
      };
    case GET_ACCEPTED_DELIVERED_FAILURE:
      return {
        ...state,
        acceptedDeliveredDataStatus: "failed",
      };
    case GET_FAVOURITE_BUSINESS_REQUESTED:
      return {
        ...state,
        getFavouriteBuisnessDataStatus: "request",
      };

    case GET_FAVOURITE_BUSINESS_SUCCESS:
      return {
        ...state,
        getFavouriteBuisnessDataStatus: "Success",
        getFavouriteBuisnessData: payload,
      };
    case GET_FAVOURITE_BUSINESS_FAILURE:
      return {
        ...state,
        getFavouriteBuisnessDataStatus: "failed",
        getFavouriteBuisnessData: [],
      };
    case ADD_FAVOURITE_BUSINESS_REQUESTED:
      return {
        ...state,
        addFavouriteBuisnessDataStatus: "request",
        getFavouriteBuisnessData: [],
      };

    case ADD_FAVOURITE_BUSINESS_SUCCESS:
      return {
        ...state,
        addFavouriteBuisnessDataStatus: "Success",
        addFavouriteBuisnessData: payload,
      };
    case ADD_FAVOURITE_BUSINESS_FAILURE:
      return {
        ...state,
        addFavouriteBuisnessDataStatus: "failed",
      };
    case ADD_UN_FAVOURITE_BUSINESS_REQUESTED:
      return {
        ...state,
        addFavouriteBuisnessDataStatus: "request",
      };

    case ADD_UN_FAVOURITE_BUSINESS_SUCCESS:
      return {
        ...state,
        addFavouriteBuisnessDataStatus: "Success",
        addUnFavouriteBuisnessData: payload,
      };
    case ADD_UN_FAVOURITE_BUSINESS_FAILURE:
      return {
        ...state,
        addFavouriteBuisnessDataStatus: "failed",
      };
    case GET_RECOMMENDED_SERVICE_REQUESTED:
      return {
        ...state,
        getRecommendedServiceStatus: "request",
      };

    case GET_RECOMMENDED_SERVICE_SUCCESS:
      return {
        ...state,
        getRecommendedServiceStatus: "Success",
        recommendedServiceData: payload,
      };
    case GET_RECOMMENDED_SERVICE_FAILURE:
      return {
        ...state,
        getRecommendedServiceStatus: "failed",
      };
    case LOCATION_CHANGE:
      return {
        ...state,
        fetchProductDataStatus: "pending",
        fetchServiceDataStatus: "pending",

      };
    default:
      return state;
  }
}
